import AppRoutes from './routes';

/** App shell — just the route table. Layouts wrap each page individually. */
export default function App() {
  return <AppRoutes />;
}
